import { useState, useEffect } from 'react';

interface UseGroundStationsProps {
  groundStations?: any[];
  selectedGroundStation?: string | number;
  onGroundStationSelect?: (stationName: string) => void;
}

export const useGroundStations = ({ 
  groundStations, 
  selectedGroundStation, 
  onGroundStationSelect 
}: UseGroundStationsProps) => {
  const [localGroundStations, setLocalGroundStations] = useState<any[]>([]);
  const [localSelectedGroundStation, setLocalSelectedGroundStation] = useState<any>(null);

  // 지상국 데이터 처리
  useEffect(() => {
    if (groundStations && groundStations.length > 0) {
      setLocalGroundStations(groundStations);
      
      // "SACHEON A/T" 지상국을 기본 선택 (selectedGroundStation이 없을 때만)
      if (!selectedGroundStation && !localSelectedGroundStation) {
        const sacheonStation = groundStations.find(station => 
          station.name === 'SACHEON A/T' || station.name?.includes('사천') || station.name?.includes('Sacheon')
        );
        const defaultStation = sacheonStation || groundStations[0];
        setLocalSelectedGroundStation(defaultStation);
        onGroundStationSelect?.(defaultStation.name);
      }
    }
  }, [groundStations, selectedGroundStation, localSelectedGroundStation, onGroundStationSelect]);

  // 선택된 지상국이 변경될 때
  useEffect(() => {
    if (selectedGroundStation && groundStations) {
      const station = groundStations.find(s => s.id === selectedGroundStation || s.groundStationId === selectedGroundStation);
      if (station) {
        setLocalSelectedGroundStation(station);
      }
    }
  }, [selectedGroundStation, groundStations]);

  return {
    localGroundStations,
    localSelectedGroundStation
  };
};
